export enum TITLE {
  MR = 'Mr',
  MRS = 'Mrs',
  MISS = 'Miss',
  MS = 'Ms',
  MX = 'Mx',
  DR = 'Dr',
  OTHER = 'Other',
}
